export default __webpack_public_path__ + "static/media/andecha.0dab4ed7.svg";